
import { gql } from '@apollo/client';

export const CREATE_BILL_RECEIPT = gql`
  mutation CreateBillReceipt($input: CreateBillReceiptInput!) {
    createBillReceipt(input: $input) {
      success
      errorMessage
    }
  }
`;

export const REVOKE_BILL_RECEIPT = gql`
  mutation RevokeBillReceipt($id: ID!, $reason: String) {
    revokeBillReceipt(id: $id, reason: $reason) {
      success
      errorMessage
    }
  }
`;
